import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import { useSafeTranslation } from '../../../hooks/useSafeTranslation';
import { useState } from 'react';

export const useWaitingScreen = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openWaitingScreen = () => {
    setIsOpen(true);
  };

  const closeWaitingScreen = () => {
    setIsOpen(false);
  };

  return { isOpen, openWaitingScreen, closeWaitingScreen };
};

export const WaitingScreen = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { t } = useSafeTranslation();
  return (
    <Modal closeOnOverlayClick={false} onClose={onClose} isOpen={isOpen} size="xl" isCentered>
      <ModalOverlay
        sx={{
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }}
      />
      <ModalContent>
        <ModalBody>
          <div className="flex flex-col items-center justify-center h-full p-spacing-xl">
            <LoadingSpinner state={true} />

            <p>{t('waiting_screen_message')}</p>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
